import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = ["href", "target", "rel"];
const _hoisted_2 = {
    key: 0,
    class: "mt-6 flex flex-col gap-5"
};
import ButtonWithArrow from '@atoms/ButtonWithArrow.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'DesktopNavLink',
    props: {
        navItem: {
            type: Object,
            required: true,
        },
    },
    setup(__props) {
        const props = __props;
        if (props.navItem.children && props.navItem.children.length === 0) {
            delete props.navItem.children;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("a", {
                    href: __props.navItem.url,
                    target: __props.navItem.target || '_self',
                    rel: __props.navItem.target === '_blank' ? 'noopener noreferrer' : null,
                    class: "flex items-center justify-between font-serif text-desktopNav font-normal"
                }, _toDisplayString(__props.navItem.label), 9, _hoisted_1),
                (__props.navItem.children)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.navItem.children, (child) => {
                            return (_openBlock(), _createElementBlock("li", {
                                key: child.objectID
                            }, [
                                _createVNode(ButtonWithArrow, {
                                    text: child.label,
                                    url: child.url,
                                    target: child.target,
                                    class: "!text-white"
                                }, null, 8, ["text", "url", "target"])
                            ]));
                        }), 128))
                    ]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
